import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Music from './components/Music/Music';
import Videos from './components/Videos/Videos';
import Gallery from './components/Gallery/Gallery';
import Events from './components/Events/Events';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import LanguageRedirect from './components/LanguageRedirect';
import Privacy from './components/Privacy/Privacy';
import QRCode from './components/QRCode/QRCode';
import './App.css';

const HomePage = () => {
  return (
        <div className="App">
          <Header />
          <Hero />
          <About />
          <Music />
          <Videos />
          <Gallery />
          <Events />
          <Contact />
          <Footer />
        </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <LanguageProvider>
          <Routes>
            <Route path="/cz" element={<LanguageRedirect />} />
            <Route path="/en" element={<LanguageRedirect />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/qr" element={<QRCode />} />
            <Route path="/events/:slug" element={<HomePage />} />
            <Route path="/" element={<HomePage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
      </LanguageProvider>
    </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
